import React, { PureComponent, PropTypes } from 'react';
import Immutable from 'immutable';
import ImmutablePropTypes from 'react-immutable-proptypes';
import InlineSVG from 'svg-inline-react';

import { flightSeatAttributes } from 'constants/flightSeats';
import emptySeatIcon from './images/EmptySeat.svg';
import infantSeatIcon from './images/InfantSeat.svg';

import './AirlineSeat.scss';

export default class AirlineSeat extends PureComponent {
  static propTypes = {
    flightSeat: ImmutablePropTypes.mapContains({
      available: PropTypes.bool.isRequired,
      flightSeatAttributes: ImmutablePropTypes.listOf(PropTypes.string),
      seatNumber: PropTypes.string,
    }).isRequired,
    paxType: PropTypes.string.isRequired,
    rowNumber: PropTypes.string.isRequired,
  };

  getSeatIcon() {
    const { flightSeat, paxType } = this.props;

    const seatAttributes = flightSeat.get('flightSeatAttributes') || Immutable.List();
    let seatIcon;

    if (!seatAttributes.includes(flightSeatAttributes.AISLE) && !seatAttributes.includes(flightSeatAttributes.ABSENT_SEAT)) {
      if (seatAttributes.includes(flightSeatAttributes.INFANTS_ALLOWED) && paxType === 'adultWithInfant') {
        seatIcon = infantSeatIcon;
      } else {
        seatIcon = emptySeatIcon;
      }
    }

    return seatIcon;
  }

  render() {
    const { flightSeat, rowNumber } = this.props;
    const seatAttributes = flightSeat.get('flightSeatAttributes') || Immutable.List();

    const isAvailable = flightSeat.get('available');
    const isAisle = seatAttributes.includes(flightSeatAttributes.AISLE);
    const seatIcon = this.getSeatIcon();

    return (
      <div className="airline-seat" onClick={this.handleSeatClick}>
        { isAisle && rowNumber }
        { seatIcon && <InlineSVG className={`airline-seat__icon airline-seat__icon--${isAvailable ? 'available' : 'unavailable'}`} src={seatIcon} /> }
      </div>
    );
  }
}



/** WEBPACK FOOTER **
 ** ./src/components/AirlineSeatSelection/AirlineSeat.jsx
 **/